// T-17 · Una sola forma de escribir una CANTIDAD, por unidad.
//
// EL PROBLEMA, MEDIDO. En México el punto es el separador decimal y la
// coma el de miles. Una cantidad guardada como `numeric(_,3)` llega del
// servidor como «9.000» o «10.000», y pintada tal cual se lee como
// «nueve mil» / «diez mil» — cuando son nueve y diez. Y diez mil piezas
// pintadas «10000», sin la coma de miles, cuesta leerlas de un vistazo.
//
// LA REGLA, POR UNIDAD:
//   · Lo que se cuenta de una en una —piezas, cajas, paquetes— NO lleva
//     decimales: media pieza no existe.
//   · Lo que se mide —kilos, gramos, litros, mililitros, metros,
//     centímetros— lleva LOS DECIMALES QUE HAGAN FALTA y ni uno más: 9 kg
//     es «9», 9.5 kg es «9.5», 9.250 kg es «9.25». Los ceros de relleno
//     se quitan.
//   · En ambos casos, separador de miles de México: «10,000», no «10000»
//     ni «10.000».
//
// Se usa `Intl.NumberFormat('es-MX')`, que pone la coma de miles y, con
// `maximumFractionDigits`, recorta los ceros sobrantes solo.

// Las unidades que se cuentan de una en una. El resto se mide.
const UNIDADES_ENTERAS = new Set(['PIEZA', 'PZA', 'CAJA', 'PAQUETE', 'UNIDAD', 'U']);

// Cuántos decimales se le permiten a una unidad. Tres es el tope del
// kárdex (`numeric(_,3)`); las medidas nunca guardan más.
const MAX_DECIMALES_MEDIDA = 3;

export function decimalesDeUnidad(unidad) {
  const u = String(unidad || '').trim().toUpperCase();
  return UNIDADES_ENTERAS.has(u) ? 0 : MAX_DECIMALES_MEDIDA;
}

// La cantidad, ya lista para pintar. Sin unidad se trata como medida
// (recorta ceros igual), así que un entero se ve limpio de todas formas.
export function formatearCantidad(n, unidad) {
  const num = Number(n);
  if (!Number.isFinite(num)) return '0';
  return new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimalesDeUnidad(unidad),
  }).format(num);
}

// La cantidad con su unidad detrás: «10,000 PIEZA», «9.25 KG». Cuando no
// hay unidad, solo el número. La etiqueta la pinta cada pantalla como
// prefiera; esto solo pega número y unidad con un espacio.
export function cantidadConUnidad(n, unidad) {
  const texto = formatearCantidad(n, unidad);
  const u = String(unidad || '').trim();
  return u ? `${texto} ${u}` : texto;
}
